<template>
  <Collapse>
    <template #label="{ toggle, isOpen }">
      <button
        class="flex w-full flex-row items-center justify-between p-4"
        @click="toggle"
      >
        <span class="text-lg">{{ $t(`sorting_select.sort_by`) }}</span>
        <IconUp v-if="isOpen" class="size-4" />
        <IconDown v-else class="size-4" />
      </button>
    </template>

    <template #collapse-content="{ close }">
      <MobileSortingItemsList
        :items="items"
        :selected="selectedSortName"
        class="w-full border-0 px-4 pb-5"
        @click:item="close"
      />
    </template>
  </Collapse>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { SortValue } from '#layers/base/utils/sort'
import MobileSortingItemsList from '~/components/sorting/MobileSortingItemsList.vue'
import Collapse from '~/components/ui/collapse/Collapse.vue'
import useSorting from '#layers/base/composables/useSorting'

const props = defineProps<{ values: SortValue[] }>()

const { selectedSortName } = useSorting()

const items = computed(() => Object.values(props.values || {}))
</script>
